import React from "react";
import { Table } from "antd";
import styles from "./FlatTable.module.scss";

export const FlatTable: React.FC = () => {
  return <div>йа табличко</div>;
};
